const ActionTypeMap: { [key: number]: string } = {
    1: "新增",
    2: "修改",
    3: "刪除",
};

const ErrorCodeMap: { [k: number]: string } = {
    0: "<錯誤代碼： 0> 未處理",

    1: "操作成功",

    2: "<錯誤代碼： 2> 操作失敗",
    3: "<錯誤代碼： 3> 伺服器錯誤",
    4: "<錯誤代碼： 4> 沒有權限執行此操作",

    101: "<錯誤代碼： 101> 輸入舊密碼錯誤",
    102: "<錯誤代碼： 102> 密碼不得輸入與舊密碼相同",
    103: "<錯誤代碼： 103> 使用者不存在",
    104: "<錯誤代碼： 104> 使用者已上鎖",
    105: "<錯誤代碼： 105> 使用者登入錯誤",
    106: "<錯誤代碼： 106> 超過重置密碼效期",
    107: "<錯誤代碼： 107> 驗證碼錯誤",
    111: "<錯誤代碼： 111> 您已從其他地方登出，請重新登入",

    1101: "<錯誤代碼： 1101> 條件不符合",

    1301: "<錯誤代碼： 1301> 取得資料錯誤",
    1302: "<錯誤代碼： 1302> 取得列表統計錯誤",

    1401: "<錯誤代碼： 1401> 資料庫寫入錯誤",
    1402: "<錯誤代碼： 1402> 資料庫更新錯誤",
    1403: "<錯誤代碼： 1403> 資料庫刪除錯誤",
    1404: "<錯誤代碼： 1404> 此筆資料已存在修改中的暫存檔，請至待放行資料進行修改",

    1501: "<錯誤代碼： 1501> 此筆異常排程正在執行中，無法執行其他排程",

    //---------------------------------------------------------------------------
    // 前端自定義提示文案 規則是 萬： { 1: 後端, 2: 前端 }, 千： WF規劃幾之幾, 百： WF規劃幾之幾

    /* 共通項目 */
    10000: "統一編號格式錯誤",
    10001: "該統編已存在",
    10002: "查無此統編",
    10003: "因查詢之資料明細超過1萬筆，已將資料匯出至報表專區，請至報表專區下載，謝謝",
    10004: "因匯出之資料明細超過2萬筆，已將資料匯出至報表專區，請至報表專區下載，謝謝",
    
    // 格式類提示 10100起
    10100: "信箱格式錯誤",
    /* 共通項目 */

    /* 後端1-2對帳 11200起 */
    11200: "請選取特店",
    11201: "請選取日期",
    11202: "請選取適當區間",
    11203: "目前尚無資料，無法列印",
    11204: "設定錯誤",
    11205: "請選取指定特店",
    11207: "匯出超過上限",
    /* 後端1-2對帳 11200起 */

    /* 後端2-1帳號 12100起 */
    12100: "帳號類型錯誤",
    /* 後端2-1帳號 12100起 */

    /* 後端3-1帳號 13100起 */
    13100: "請選擇帳號權限",
    /* 後端3-1帳號 13100起 */
};

enum ErrorHintMap {
    TidNumberError = 10000,
    TidNumberExist = 10001,
    TidNumberEmpty = 10002,
    ListCountExceed = 10003,
    ExcelCountExceed = 10004,    

    ValidateEmail = 10100,

    RequireStore = 11200,
    RequireDate = 11201,
    DatePeriodError = 11202,
    PrintEmptyData = 11203,
    SettingPrintDataError = 11204,
    RequireSpecificStore = 11205,
    ExportNumExceedLimit = 11207,

    StoreAccountTypeError = 12100,

    EReceiptUserPermissionEmpty = 13100,
}

export const Common = {
    ActionTypeMap,
    ErrorCodeMap,
    ErrorHintMap,
};
